module.exports = global["p2"] = require("-!/Users/jesper/WebstormProjects/king-rail/node_modules/phaser/build/custom/p2.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/phaser/build/custom/p2.js
 ** module id = 302
 ** module chunks = 1
 **/